module.exports={LOGIN:"LOGIN",ABORTED:"Login was aborted by user.",TOKEN_EXPIRED:"Your session has expired. Please login again."};